import isNil from 'lodash-es/isNil';
import type { Locale } from '@yi/core';
import { i18n_articles } from '@yi/i18n/phrases/i18n_articles';
import { i18n_breathwork } from '@yi/i18n/phrases/i18n_breathwork';
import { i18n_challenges } from '@yi/i18n/phrases/i18n_challenges';
import { i18n_courses } from '@yi/i18n/phrases/i18n_courses';
import { i18n_docs_and_films } from '@yi/i18n/phrases/i18n_docs_and_films';
import { i18n_meditations } from '@yi/i18n/phrases/i18n_meditations';
import { i18n_my_library } from '@yi/i18n/phrases/i18n_my_library';
import { i18n_our_teachers } from '@yi/i18n/phrases/i18n_our_teachers';
import { i18n_podcasts } from '@yi/i18n/phrases/i18n_podcasts';
import { i18n_poses } from '@yi/i18n/phrases/i18n_poses';
import { i18n_premium_trainings } from '@yi/i18n/phrases/i18n_premium_trainings';
import { i18n_yoga_classes } from '@yi/i18n/phrases/i18n_yoga_classes';

import {
  ARTICLES_PATHNAME,
  CHALLENGES_PATHNAME,
  CLASSES_PATHNAME,
  COURSES_PATHNAME,
  LIBRARY_PATHNAME,
  MEDITATIONS_PATHNAME,
  PODCASTS_PATHNAME,
  POSES_PATHNAME,
  BREATHWORK_PATHNAME,
  PREMIUM_TRAININGS_PATHNAME,
  SERIES_PATHNAME,
  TEACHERS_PATHNAME,
} from '~/src/common/routes';

import { removeLocalePathSegment } from './removeLocalePathSegment';

const pathnameRegExp = /(?<rootPath>^\/[\w-_]+)(\/(\w+))*/i;

export function getPageTitleByHrefPathname(hrefPathname: string, locale: Locale): string {
  const hrefPathnameWithoutLocale = removeLocalePathSegment(hrefPathname);
  const results = pathnameRegExp.exec(hrefPathnameWithoutLocale);
  const rootPathname = results?.groups?.rootPath;
  if (isNil(rootPathname)) {
    console.error(
      `invalid href pathname: ${hrefPathname}; (href without locale: ${hrefPathnameWithoutLocale})`,
    );
    return '';
  }

  switch (rootPathname) {
    case CLASSES_PATHNAME:
      return i18n_yoga_classes(locale);
    case MEDITATIONS_PATHNAME:
      return i18n_meditations(locale);
    case BREATHWORK_PATHNAME:
      return i18n_breathwork(locale);
    case SERIES_PATHNAME:
      return i18n_docs_and_films(locale);
    case ARTICLES_PATHNAME:
      return i18n_articles(locale);
    case COURSES_PATHNAME:
      return i18n_courses(locale);
    case CHALLENGES_PATHNAME:
      return i18n_challenges(locale);
    case TEACHERS_PATHNAME:
      return i18n_our_teachers(locale);
    case LIBRARY_PATHNAME:
      return i18n_my_library(locale);
    case PREMIUM_TRAININGS_PATHNAME:
      return i18n_premium_trainings(locale);
    case PODCASTS_PATHNAME:
      return i18n_podcasts(locale);
    case POSES_PATHNAME:
      return i18n_poses(locale);

    default: {
      console.error(`title for pathname: "${rootPathname}" is not defined`);
      return '';
    }
  }
}
